// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/imgs/sustainaple_engineer.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.Conference_slider {
    padding-top: 80px !important;
    background-color: #f0f1eb;
    padding-bottom: 100px;
    /* border-radius: 0px 0px  150px 150px; */
    
}
@media (max-width:768px) {
        .Conference_slider{

    padding-top: 0 !important;
        }
}
.owl_image {
    height: 450px;
    width: 100%;

}
.Conference_slider .title { 
color: #0586BC;
}
.Conference_slider .Conference_slider-image {
height: 550px;
}
.Conference_slider .cta-button {
    padding: 14px 14px;
    background: rgba(224, 118, 35, 1);
    color: white;
    width: 179px;
    border-radius: 10px;
    transition: .3 ease-in-out;
}
.Conference_slider .cta-button:hover {
    background-color: white;
    color: rgba(224, 118, 35, 1);
}

.Conference_slider .title {
    position: relative;
    padding: 20px 0;
}
.Conference_slider .title::after{
    content: "";
    width: 3px;
    height: 100%;
    position: absolute;
    left: -20px;
    top: 0;
    background-color: rgba(224, 118, 35, 1);
}
.countdown  {
    width: 60%;
    left: 20%;
    border-radius: 20px;
    background: linear-gradient(157.65deg, rgba(255, 255, 255, 0.68) 10.35%, rgba(255, 255, 255, 0.204) 69.41%);
border: 2px solid white;
    bottom: -50px;
}
.countdown .countdown-item{
    position: relative;
}
.countdown .countdown-item::after{
    position: absolute;
    content: "";
    width: 3px;
    height: 80%;
    right: -37px;
    top: 10%;
    background-color: rgba(224, 118, 35, 1);
}
.conference-objectives {
    background: linear-gradient(131.56deg, rgba(231, 244, 250, 0.84) 1.02%, rgba(122, 206, 242, 0) 98.13%);
}
.conference-objectives .icon:hover {
    color: #2ca1d0;
}
.conference-objectives .container{
    padding-top: 100px;
    display: flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
}
.conference-objectives-div:nth-child(1) {
    border-left: 5px solid #0586BC;
    border-right:0;

}
.conference-objectives-div:nth-child(2) {
    border-left: 5px solid #3D9B11;
    border-right:0;

}
.conference-objectives-div:nth-child(3) {
    border-left: 5px solid #FE86C3;
    border-right:0;

}
body:lang(ar) .conference-objectives-div:nth-child(1) {
    border-right: 5px solid #0586BC;
    border-left:0;
}
body:lang(ar) .conference-objectives-div:nth-child(2) {
    border-right: 5px solid #3D9B11;
    border-left:0;
}
body:lang(ar) .conference-objectives-div:nth-child(3) {
    border-right: 5px solid #FE86C3;
    border-left:0;
}
.EnergyImage {
    padding:100px 0;
}
.EnergyImage img {
    width: 100%;
    height: 350px;
}
.EnergyImage i {
    background-color: rgba(224, 118, 35, 1);
    color: white;
    /* padding: 15px; */
    height: 60px;
    width: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    border-radius: 50%;
}
@media (max-width:992px) {
    .Conference_slider {
    margin-top: 0 !important;
    border-radius: 0px;
    }
    .countdown {
        width: 98%;
        left: 1%;
    }
    .countdown .countdown-item::after{
        width: 1px;
        right: -5px;
        top: 10%;
    }
}
@media (max-width:768px) {
    .EnergyImage i {
        margin-bottom:20px ;
    }
.EnergyImage {
    padding: 10px 0;
}
}

/* conference */


.conference .img_conference {
    position: relative;
}




.conference .img_conference img {
    height: 250px;
    width: 100%;
    object-fit: cover;
}

.conference .hed {
    color: rgba(224, 118, 35, 1);
}

.conference .par {
    color: rgba(43, 43, 43, 1);
}

/* conference */
.conference .img_conference {
    position: relative;
}
.conference .img_conference img {
    height: 300px;
    object-fit: cover;
}
.conference .hed {
    color: rgba(224, 118, 35, 1);
}
.conference .par {
    color: rgba(43, 43, 43, 1);
}
/* sustainable */
.sustainable {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top;
}
.sustainable .line {
    background: rgba(39, 58, 89, 1);
    width: 2px;
    position: relative;
    transform: translate(0, -10px);
}
.sustainable .line::after {
    content: "";
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: rgba(39, 58, 89, 1);
    bottom: 0;
    right: -5px;

}
.sustainable .hed {
    color: rgba(224, 118, 35, 1);
}
.sustainable .btn {
    background-color: rgba(5, 134, 188, 1);
    color: #fff;
}

.company-logo {
    width: 160px;
    height: 160px;
    border-radius: 50%;
    border: 2px solid #ff8000;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    margin-left: auto;
    margin-right: auto;
}

.company-logo img {
    max-width: 100%;
    max-height: 100%;
}

.section-title {
    margin-bottom: 30px;
    color: black;
}

.compaines{
    text-align: center;
    width: -moz-fit-content;
    width: fit-content;
    position: relative;
  
}
.image-company {
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 3px;
}
.ellipse{
   
    position: absolute;
    width: 100px;
    top: 35px;
    height: 100px;
    left: 34%;
    /* border-radius: 50% */
}

.compaines{
  border-bottom: 2px solid #0586BC;
  padding-bottom:10px;
  position: relative;
  margin-bottom: 60px;
}

.compaines::after{
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
    left: 50%;
    bottom: -10px;
    background-color: #0586BC;
}


.section-title {
    text-align: center;
    margin-bottom: 50px;
    display: flex;
    justify-content: center;
}

.speaker-card {
    position: relative;
    text-align: center;
    padding: 30px 10px;
    border: 1px solid #ddd;
    border-radius: 10px;
    transition: transform 0.3s ease;
    height: 250px;

}
.speaker-card:hover {
    transform: translateY(-10px);
    background-color: #0586BC;
    color: white;
}
.speaker-card:hover.speaker-card p  {

    color: white;
}


.speaker-card img {
    border-radius: 50%;
    top: -50px;
    width: 80px;
    height: 80px;
    object-fit: cover;
    margin-bottom: 15px;
    position: absolute;
    right: 35%; 
}
.highlighted-speaker {
    transform: translateY(-30px);
}


.speaker-card h4 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
}

.speaker-card p {
    font-size: 14px;
    /* color: #666; */
    margin-bottom: 20px;
}

.speaker-card .social-icons {
    margin-top: 15px;
}

.social-icons a {
    margin: 0 5px;
    color: #0586BC;
    font-size: 16px;
}

.highlighted-speaker {
    background-color: #0586BC;
    color: white;
}


.highlighted-speaker p, 
.highlighted-speaker h4 ,
.highlighted-speaker i{
    color: white;
}
.conference_item{
    background: linear-gradient(131.56deg, rgba(231, 244, 250, 0.84) 1.02%, rgba(122, 206, 242, 0) 98.13%);
    padding: 20px 0;
    justify-content: center;
    border-radius: 10px;
}
.conference_item_pargrph {
    height: 280px;
}`, "",{"version":3,"sources":["webpack://./src/pages/SustainableEngineering/ConferenceObjectives.css"],"names":[],"mappings":";AACA;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,qBAAqB;IACrB,yCAAyC;;AAE7C;AACA;QACQ;;IAEJ,yBAAyB;QACrB;AACR;AACA;IACI,aAAa;IACb,WAAW;;AAEf;AACA;AACA,cAAc;AACd;AACA;AACA,aAAa;AACb;AACA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;AAC9B;AACA;IACI,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,uCAAuC;AAC3C;AACA;IACI,UAAU;IACV,SAAS;IACT,mBAAmB;IACnB,2GAA2G;AAC/G,uBAAuB;IACnB,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,uCAAuC;AAC3C;AACA;IACI,sGAAsG;AAC1G;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,8BAA8B;IAC9B,cAAc;;AAElB;AACA;IACI,8BAA8B;IAC9B,cAAc;;AAElB;AACA;IACI,8BAA8B;IAC9B,cAAc;;AAElB;AACA;IACI,+BAA+B;IAC/B,aAAa;AACjB;AACA;IACI,+BAA+B;IAC/B,aAAa;AACjB;AACA;IACI,+BAA+B;IAC/B,aAAa;AACjB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,aAAa;AACjB;AACA;IACI,uCAAuC;IACvC,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI;IACA,wBAAwB;IACxB,kBAAkB;IAClB;IACA;QACI,UAAU;QACV,QAAQ;IACZ;IACA;QACI,UAAU;QACV,WAAW;QACX,QAAQ;IACZ;AACJ;AACA;IACI;QACI,mBAAmB;IACvB;AACJ;IACI,eAAe;AACnB;AACA;;AAEA,eAAe;;;AAGf;IACI,kBAAkB;AACtB;;;;;AAKA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,eAAe;AACf;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,0BAA0B;AAC9B;AACA,gBAAgB;AAChB;IACI,yDAAmE;IACnE,sBAAsB;IACtB,4BAA4B;IAC5B,wBAAwB;AAC5B;AACA;IACI,+BAA+B;IAC/B,UAAU;IACV,kBAAkB;IAClB,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,SAAS;IACT,WAAW;;AAEf;AACA;IACI,4BAA4B;AAChC;AACA;IACI,sCAAsC;IACtC,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;;AAEtB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;AACZ;AACA;;IAEI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,aAAa;IACb,yBAAyB;AAC7B;;;AAGA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,+BAA+B;IAC/B,aAAa;;AAEjB;AACA;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,YAAY;AAChB;AACA;;IAEI,YAAY;AAChB;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,4BAA4B;AAChC;;;AAGA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;;AAGA;;;IAGI,YAAY;AAChB;AACA;IACI,sGAAsG;IACtG,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB","sourcesContent":["\n.Conference_slider {\n    padding-top: 80px !important;\n    background-color: #f0f1eb;\n    padding-bottom: 100px;\n    /* border-radius: 0px 0px  150px 150px; */\n    \n}\n@media (max-width:768px) {\n        .Conference_slider{\n\n    padding-top: 0 !important;\n        }\n}\n.owl_image {\n    height: 450px;\n    width: 100%;\n\n}\n.Conference_slider .title { \ncolor: #0586BC;\n}\n.Conference_slider .Conference_slider-image {\nheight: 550px;\n}\n.Conference_slider .cta-button {\n    padding: 14px 14px;\n    background: rgba(224, 118, 35, 1);\n    color: white;\n    width: 179px;\n    border-radius: 10px;\n    transition: .3 ease-in-out;\n}\n.Conference_slider .cta-button:hover {\n    background-color: white;\n    color: rgba(224, 118, 35, 1);\n}\n\n.Conference_slider .title {\n    position: relative;\n    padding: 20px 0;\n}\n.Conference_slider .title::after{\n    content: \"\";\n    width: 3px;\n    height: 100%;\n    position: absolute;\n    left: -20px;\n    top: 0;\n    background-color: rgba(224, 118, 35, 1);\n}\n.countdown  {\n    width: 60%;\n    left: 20%;\n    border-radius: 20px;\n    background: linear-gradient(157.65deg, rgba(255, 255, 255, 0.68) 10.35%, rgba(255, 255, 255, 0.204) 69.41%);\nborder: 2px solid white;\n    bottom: -50px;\n}\n.countdown .countdown-item{\n    position: relative;\n}\n.countdown .countdown-item::after{\n    position: absolute;\n    content: \"\";\n    width: 3px;\n    height: 80%;\n    right: -37px;\n    top: 10%;\n    background-color: rgba(224, 118, 35, 1);\n}\n.conference-objectives {\n    background: linear-gradient(131.56deg, rgba(231, 244, 250, 0.84) 1.02%, rgba(122, 206, 242, 0) 98.13%);\n}\n.conference-objectives .icon:hover {\n    color: #2ca1d0;\n}\n.conference-objectives .container{\n    padding-top: 100px;\n    display: flex;\n    flex-direction:column;\n    justify-content: center;\n    align-items: center;\n}\n.conference-objectives-div:nth-child(1) {\n    border-left: 5px solid #0586BC;\n    border-right:0;\n\n}\n.conference-objectives-div:nth-child(2) {\n    border-left: 5px solid #3D9B11;\n    border-right:0;\n\n}\n.conference-objectives-div:nth-child(3) {\n    border-left: 5px solid #FE86C3;\n    border-right:0;\n\n}\nbody:lang(ar) .conference-objectives-div:nth-child(1) {\n    border-right: 5px solid #0586BC;\n    border-left:0;\n}\nbody:lang(ar) .conference-objectives-div:nth-child(2) {\n    border-right: 5px solid #3D9B11;\n    border-left:0;\n}\nbody:lang(ar) .conference-objectives-div:nth-child(3) {\n    border-right: 5px solid #FE86C3;\n    border-left:0;\n}\n.EnergyImage {\n    padding:100px 0;\n}\n.EnergyImage img {\n    width: 100%;\n    height: 350px;\n}\n.EnergyImage i {\n    background-color: rgba(224, 118, 35, 1);\n    color: white;\n    /* padding: 15px; */\n    height: 60px;\n    width: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n    border-radius: 50%;\n}\n@media (max-width:992px) {\n    .Conference_slider {\n    margin-top: 0 !important;\n    border-radius: 0px;\n    }\n    .countdown {\n        width: 98%;\n        left: 1%;\n    }\n    .countdown .countdown-item::after{\n        width: 1px;\n        right: -5px;\n        top: 10%;\n    }\n}\n@media (max-width:768px) {\n    .EnergyImage i {\n        margin-bottom:20px ;\n    }\n.EnergyImage {\n    padding: 10px 0;\n}\n}\n\n/* conference */\n\n\n.conference .img_conference {\n    position: relative;\n}\n\n\n\n\n.conference .img_conference img {\n    height: 250px;\n    width: 100%;\n    object-fit: cover;\n}\n\n.conference .hed {\n    color: rgba(224, 118, 35, 1);\n}\n\n.conference .par {\n    color: rgba(43, 43, 43, 1);\n}\n\n/* conference */\n.conference .img_conference {\n    position: relative;\n}\n.conference .img_conference img {\n    height: 300px;\n    object-fit: cover;\n}\n.conference .hed {\n    color: rgba(224, 118, 35, 1);\n}\n.conference .par {\n    color: rgba(43, 43, 43, 1);\n}\n/* sustainable */\n.sustainable {\n    background-image: url('../../assets/imgs/sustainaple_engineer.png');\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: top;\n}\n.sustainable .line {\n    background: rgba(39, 58, 89, 1);\n    width: 2px;\n    position: relative;\n    transform: translate(0, -10px);\n}\n.sustainable .line::after {\n    content: \"\";\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background-color: rgba(39, 58, 89, 1);\n    bottom: 0;\n    right: -5px;\n\n}\n.sustainable .hed {\n    color: rgba(224, 118, 35, 1);\n}\n.sustainable .btn {\n    background-color: rgba(5, 134, 188, 1);\n    color: #fff;\n}\n\n.company-logo {\n    width: 160px;\n    height: 160px;\n    border-radius: 50%;\n    border: 2px solid #ff8000;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: white;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.company-logo img {\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.section-title {\n    margin-bottom: 30px;\n    color: black;\n}\n\n.compaines{\n    text-align: center;\n    width: fit-content;\n    position: relative;\n  \n}\n.image-company {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    gap: 3px;\n}\n.ellipse{\n   \n    position: absolute;\n    width: 100px;\n    top: 35px;\n    height: 100px;\n    left: 34%;\n    /* border-radius: 50% */\n}\n\n.compaines{\n  border-bottom: 2px solid #0586BC;\n  padding-bottom:10px;\n  position: relative;\n  margin-bottom: 60px;\n}\n\n.compaines::after{\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n    left: 50%;\n    bottom: -10px;\n    background-color: #0586BC;\n}\n\n\n.section-title {\n    text-align: center;\n    margin-bottom: 50px;\n    display: flex;\n    justify-content: center;\n}\n\n.speaker-card {\n    position: relative;\n    text-align: center;\n    padding: 30px 10px;\n    border: 1px solid #ddd;\n    border-radius: 10px;\n    transition: transform 0.3s ease;\n    height: 250px;\n\n}\n.speaker-card:hover {\n    transform: translateY(-10px);\n    background-color: #0586BC;\n    color: white;\n}\n.speaker-card:hover.speaker-card p  {\n\n    color: white;\n}\n\n\n.speaker-card img {\n    border-radius: 50%;\n    top: -50px;\n    width: 80px;\n    height: 80px;\n    object-fit: cover;\n    margin-bottom: 15px;\n    position: absolute;\n    right: 35%; \n}\n.highlighted-speaker {\n    transform: translateY(-30px);\n}\n\n\n.speaker-card h4 {\n    font-size: 18px;\n    font-weight: bold;\n    margin-bottom: 10px;\n}\n\n.speaker-card p {\n    font-size: 14px;\n    /* color: #666; */\n    margin-bottom: 20px;\n}\n\n.speaker-card .social-icons {\n    margin-top: 15px;\n}\n\n.social-icons a {\n    margin: 0 5px;\n    color: #0586BC;\n    font-size: 16px;\n}\n\n.highlighted-speaker {\n    background-color: #0586BC;\n    color: white;\n}\n\n\n.highlighted-speaker p, \n.highlighted-speaker h4 ,\n.highlighted-speaker i{\n    color: white;\n}\n.conference_item{\n    background: linear-gradient(131.56deg, rgba(231, 244, 250, 0.84) 1.02%, rgba(122, 206, 242, 0) 98.13%);\n    padding: 20px 0;\n    justify-content: center;\n    border-radius: 10px;\n}\n.conference_item_pargrph {\n    height: 280px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
